import { Directive, HostListener, Input, OnInit } from '@angular/core';
import { ScrollToService } from './scrollTo.service';


export class ScrollToDirective implements OnInit {

     scrollTo: any;
     scrollDuration: number;
     scrollOffset: number;

    constructor(private scrollToService: ScrollToService) {}

    ngOnInit(): void {
        this.scrollDuration = (!this.scrollDuration) ? 500 : this.scrollDuration;
        this.scrollOffset = (!this.scrollOffset) ? 0 : this.scrollOffset;
    }

    
    onMouseClick() {
        this.scrollToService.scrollTo(this.scrollTo, this.scrollDuration, this.scrollOffset);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[scrollTo]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ScrollToService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'scrollTo': [{ type: Input, args: ['scrollTo', ] },],
'scrollDuration': [{ type: Input, args: ['scrollDuration', ] },],
'scrollOffset': [{ type: Input, args: ['scrollOffset', ] },],
'onMouseClick': [{ type: HostListener, args: ['mousedown', ] },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
